<p-dialog
  [(visible)]="dialogVisible"
  [header]="typeToDelete === 'TENANT' ? ('attribute.confirmTenantName' | transloco) : ('attribute.confirmOrganizationName' | transloco)"
  [style]="{ width: '35vw' }"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  (onHide)="visibleChange.emit(false)"
  appendTo="body"
>
  <hr class="mt-0">
  <div class="flex flex-column">
    <div class="grid">
      <div class="col-12">
        <div class="form-field col-12">
          <label *ngIf="typeToDelete==='TENANT'" for="name">{{'info.confirmDeleteTenant' | transloco}}:</label>
          <label *ngIf="typeToDelete==='ORGANIZATION'" for="name">{{'info.confirmDeleteOrganization' | transloco}}:</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text"  class="w-full" [(ngModel)]="nameConfirmation">
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-content-between pt-4">
    <div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="closeWithoutSaving()"
        pButton
        class="mr-2 p-button-danger"
      ></button>
    </div>
    <div class="flex justify-content-end">
      <button
        [label]="'common.delete' | transloco"
        [disabled]="!nameConfirmation || nameConfirmation.length === 0 || toDelete.name !== nameConfirmation"
        (click)="saveAndClose()"
        pButton
        class="p-button-primary"
        iconPos="right"
      ></button>
    </div>
  </div>

</p-dialog>
